import { Email, Key, Phone } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  Button,
  Typography,
  Container,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { buttonSubmitStyle, formStyle } from "../../styles";
import { useAuth } from "../../hooks/useAuth";
import useSnack from "../../hooks/useSnack";
import useApi from "../../hooks/useApi";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import SnackAlert from "../../components/SnackAlert";
import PersonIcon from "@mui/icons-material/Person";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import validator from "validator";

function Register({ showPassword, changePasswordVisibility }) {
  const navigate = useNavigate();
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [isLoading, setIsLoading] = useState(false);
  const [visibleTerms, setVisibleTerms] = useState(false);
  const [mainData, setMainData] = useState({
    name: "",
    username: "",
    password: "",
    confirm_password: "",
    phone: "",
    role_guide: "",
  });
  const [agreeTerms, setAgreeTerms] = useState(true);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const validateEmail = (email) => {
    if (!validator.isEmail(email)) {
      setEmailError("Correo electrónico no válido");
      return false;
    }
    setEmailError("");
    return true;
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^[0-9]+$/.test(value)) {
      setMainData({
        ...mainData,
        phone: value,
      });
      setPhoneError("");
    }
  };

  const Register = async (e) => {
    e.preventDefault();

    if (!agreeTerms) {
      showSnack("Debe aceptar los términos y condiciones");
      return;
    }

    if (!validateEmail(mainData.username)) {
      return;
    }

    setIsLoading(true);

    loadApi(
      "register",
      false,
      "post",
      mainData
      // remember: !!remember ? "true" : "false",
    )
      .then((response) => {
        RegisterSuccess(response);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setIsLoading(false));
  };

  async function RegisterSuccess(response) {
    showSnack(
      "Usuario creado con éxito, actívalo revisando tu e-mail",
      "success"
    );
    setTimeout(() => {
      navigate("/login");
    }, 2000);
  }

  return (
    <>
      <Container maxWidth="sm">
        <Box
          component="form"
          onSubmit={Register}
          sx={{
            mt: 4,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <TextField
            name="name"
            id="name-input"
            label="Nombre"
            variant="standard"
            sx={{ mb: { xs: 0.7 } }}
            required
            onChange={({ target }) =>
              setMainData((adata) => ({
                ...adata,
                name: target.value,
              }))
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            variant="standard"
            label="Correo electrónico"
            value={mainData.username}
            onChange={(e) => {
              setMainData((prev) => ({
                ...prev,
                username: e.target.value,
              }));
              if (!validator.isEmail(e.target.value)) {
                setEmailError("Correo electrónico no válido");
              } else {
                setEmailError("");
              }
            }}
            error={!!emailError}
            helperText={emailError}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Email />
                </InputAdornment>
              ),
            }}
            sx={{
              mb: { xs: 1 },
            }}
          />
          <TextField
            fullWidth
            variant="standard"
            label="Teléfono"
            value={mainData.phone}
            onChange={handlePhoneChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Phone />
                </InputAdornment>
              ),
            }}
            sx={{
              mb: { xs: 1 },
            }}
          />
          <TextField
            name="password"
            id="password-input"
            label="Contraseña"
            variant="standard"
            type={showPassword ? "text" : "password"}
            sx={{ mb: { xs: 0.7 } }}
            required
            onChange={({ target }) =>
              setMainData((adata) => ({
                ...adata,
                password: target.value,
              }))
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={changePasswordVisibility}>
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            name="repeatedPassword"
            id="password-repeat-input"
            label="Confirmar contraseña"
            variant="standard"
            type={showPassword ? "text" : "password"}
            sx={{ mb: { xs: 1 } }}
            required
            onChange={({ target }) =>
              setMainData((adata) => ({
                ...adata,
                confirm_password: target.value,
              }))
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={changePasswordVisibility}>
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Select
            id="investment-type"
            variant="standard"
            name="investmentType"
            defaultValue="tempText"
            required
            onChange={({ target }) =>
              setMainData((adata) => ({
                ...adata,
                role_guide: target.value,
              }))
            }
            sx={{
              mb: { xs: 1 },
              color:
                mainData.role_guide.length === 0 ? "#a7a7a7bd" : "primary.main",
            }}
          >
            <MenuItem disabled value="tempText">
              Selecciona un rol
            </MenuItem>
            <MenuItem value="grupo-inversion">Empresa</MenuItem>
            <MenuItem value="inversor-individual">Particular</MenuItem>
          </Select>
          <Box sx={{ mb: { xs: 1 } }}>
            <FormControlLabel
              label="Acepto los términos y condiciones"
              control={
                <Checkbox
                  checked={agreeTerms}
                  onChange={() => {
                    setAgreeTerms(agreeTerms ? false : true);
                  }}
                  name="agreeTerms"
                  sx={{
                    "&.Mui-checked": {
                      color: "colors.primary",
                    },
                  }}
                />
              }
            />
            <Typography
              component="p"
              mb={2}
              sx={{ cursor: "pointer" }}
              onClick={() => setVisibleTerms(!visibleTerms)}
            >
              {visibleTerms
                ? "Ocultar términos y condiciones"
                : "Ver términos y condiciones"}
            </Typography>
          </Box>

          {visibleTerms && (
            <Box
              sx={{
                overflow: "scroll",
                maxHeight: "200px",
                minHeight: "200px",
              }}
            >
              <Typography
                component="p"
                sx={{ fontWeight: "bold", fontSize: "large" }}
              >
                Política de Aceptación de Términos y Condiciones
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "bold", fontSize: "large" }}
              >
                Plataforma de Inversión “Invirte”
              </Typography>
              <br />
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                1. <strong>Objeto de la Política</strong>
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                La presente Política de Aceptación de Términos y Condiciones
                regula el proceso mediante el cual los usuarios aceptan las
                normas de uso, obligaciones y responsabilidades asociadas al
                acceso y utilización de la plataforma de inversión Invirte (en
                adelante, “la Plataforma”).
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                2. <strong>Aceptación Explícita por Parte del Usuario</strong>
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                Para utilizar la Plataforma, el usuario deberá aceptar de manera
                expresa, informada y voluntaria los Términos y Condiciones
                vigentes. Esta aceptación se realizará mediante:
              </Typography>
              <ul>
                <li>
                  Marcado de una casilla (“checkbox”) habilitada para tal fin.
                </li>
                <li>
                  Pulsación de un botón como “Acepto” o “Registrar cuenta”.
                </li>
                <li>
                  Acciones equivalentes que impliquen consentimiento explícito.
                </li>
              </ul>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                Sin esta aceptación, el usuario no podrá registrarse ni operar
                dentro de la Plataforma.
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                3. <strong>Momento de la Aceptación</strong>
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                La aceptación de los Términos y Condiciones será requerida:
              </Typography>
              <ul>
                <li>Durante el proceso de registro inicial.</li>
                <li>
                  Cada vez que se realice una modificación sustancial de los
                  mismos.
                </li>
                <li>
                  Al acceder a servicios o productos específicos que requieran
                  condiciones adicionales.
                </li>
              </ul>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                4. <strong>Disponibilidad de los Términos y Condiciones</strong>
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                Antes de aceptar, el usuario tendrá acceso permanente y gratuito
                a:
              </Typography>
              <ul>
                <li>Los Términos y Condiciones completos.</li>
                <li>La Política de Privacidad y Protección de Datos.</li>
                <li>La Política de Riesgos de Inversión.</li>
                <li>
                  Información sobre comisiones, gastos y funcionamiento de los
                  productos ofrecidos.
                </li>
              </ul>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                La documentación se mostrará de forma clara, legible y
                descargable en formato PDF.
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                5. <strong>Modificaciones y Actualizaciones</strong>
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                La Plataforma podrá actualizar los Términos y Condiciones cuando
                sea necesario. En dicho caso:
              </Typography>
              <ul>
                <li>
                  Se notificará al usuario por correo electrónico o mediante
                  aviso en la Plataforma.
                </li>
                <li>
                  La continuidad del uso requerirá la nueva aceptación
                  explícita.
                </li>
                <li>
                  Si el usuario rechaza las modificaciones, podrá solicitar la
                  cancelación de su cuenta.
                </li>
              </ul>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                6. <strong>Registro y Evidencia de Aceptación</strong>
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                La Plataforma conservará evidencia verificable de la aceptación
                de los Términos y Condiciones por parte del usuario, incluyendo:
              </Typography>
              <ul>
                <li>Fecha y hora exacta (timestamp).</li>
                <li>Versión del documento aceptado.</li>
                <li>
                  Dirección IP o identificadores técnicos del dispositivo.
                </li>
              </ul>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                Esta información será custodiada conforme a la normativa
                aplicable.
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                7. <strong>Rechazo o Revocación del Consentimiento</strong>
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                El usuario podrá revocar su consentimiento en cualquier momento,
                lo que implicará:
              </Typography>
              <ul>
                <li>Cierre de su cuenta.</li>
                <li>Imposibilidad de seguir operando en la Plataforma.</li>
                <li>
                  Liquidación o traslado de inversiones según la normativa
                  vigente.
                </li>
              </ul>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                8. <strong>Contacto para Consultas</strong>
              </Typography>
              <Typography
                component="p"
                sx={{ fontWeight: "regular", marginBottom: 2 }}
              >
                Para cualquier duda relativa a los Términos y Condiciones o al
                proceso de aceptación, el usuario podrá comunicarse con el
                servicio de atención al cliente de Invirte a través de los
                canales oficiales publicados en la Plataforma.
              </Typography>
            </Box>
          )}
          <Box textAlign="center">
            <LoadingButton
              type="submit"
              sx={{ ...buttonSubmitStyle }}
              loading={isLoading}
            >
              Registrarse
            </LoadingButton>
          </Box>
        </Box>
      </Container>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default Register;

